'use client';

import Link from 'next/link';
import Image from 'next/image';
import { Button } from '@/components/ui/button';
import { Menu } from 'lucide-react';
import { useState } from 'react';

export function MarketingHeader() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="border-b border-border/10 bg-transparent sticky top-0 z-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-14 md:h-16">
          {/* Logo - wide ratio, fills width up to container height */}
          <Link href="/" className="hover:opacity-80 transition-opacity group flex items-center" aria-label="The Way Maker - Home">
            <Image
              src="/logo.png"
              alt="The Way Maker"
              width={200}
              height={133}
              className="h-12 md:h-14 w-auto object-contain transition-transform group-hover:scale-105"
              priority
              unoptimized
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6">
            <Link href="/m/pricing" className="text-sm font-medium text-foreground/70 hover:text-gold transition-colors">
              Pricing
            </Link>
            <Link href="/m/contact" className="text-sm font-medium text-foreground/70 hover:text-gold transition-colors">
              Contact
            </Link>
            <Link href="/m/pricing">
              <Button size="sm" className="bg-gold text-charcoal hover:bg-[hsl(var(--gold)/0.9)] border border-gold/40 shadow-soft">
                Get Started
              </Button>
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-foreground/70 hover:text-foreground transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <Menu className="h-6 w-6" />
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-border/10 py-4 space-y-4">
            <Link
              href="/m/pricing"
              className="block text-sm font-medium text-foreground/70 hover:text-gold transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Pricing
            </Link>
            <Link
              href="/m/contact"
              className="block text-sm font-medium text-foreground/70 hover:text-gold transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Contact
            </Link>
            <Link href="/m/pricing" onClick={() => setMobileMenuOpen(false)}>
              <Button size="sm" className="w-full bg-gold text-charcoal hover:bg-[hsl(var(--gold)/0.9)] border border-gold/40 shadow-soft">
                Get Started
              </Button>
            </Link>
          </div>
        )}
      </div>
    </header>
  );
}
